// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-item p[data-v-f0649f16]{font-size:14px;font-weight:400;color:#ff5b61}.list-item.status-200 p[data-v-f0649f16]{color:#141c20}.list-item.status-400 p[data-v-f0649f16]{color:#bac8ce}.list-item.status-failed *[data-v-f0649f16]{color:#ff5b61}", ""]);
// Exports
module.exports = exports;
